export const EditConceptsDimensions = {
    defaultIndent: 32
}
